import type { WellTypeIcon } from 'src/shared/constants/well-type-icon';
import { addGOplanPrefix } from 'src/shared/utils/prefixes';

import type { Range } from '../../../layers/model';
import type { RawWell } from '../../../types';

export class RigOperation {
  readonly uniqueCreationKey: string | null;
  readonly data: RawWell;
  readonly color: string;
  readonly attributes: string[];
  readonly wellTypeIcon?: WellTypeIcon;
  readonly rigOperationIndex: number | null;
  readonly parentRigTitle: string;

  constructor(
    uniqueCreationKey: string | null,
    data: RawWell,
    parentRigTitle: string,
    rigOperationIndex: number | null,
    attributes: string[],
    color: string,
    wellTypeIcon?: WellTypeIcon,
  ) {
    this.uniqueCreationKey = uniqueCreationKey;
    this.data = data;
    this.color = color;
    this.attributes = attributes;
    this.rigOperationIndex = rigOperationIndex;
    this.wellTypeIcon = wellTypeIcon;
    this.parentRigTitle = parentRigTitle;
  }

  get x(): Range<number> | null {
    return null;
  }

  get title(): string {
    return this.data['GOplan_Dict_Well.name']?.toString() ?? '';
  }

  getFieldValue(fieldName: string): unknown {
    if (fieldName in this.data) {
      return this.data[fieldName];
    }
  }

  getRigId(): number | null {
    const rigIdAttr = addGOplanPrefix('RigOperation.rigId');

    if (rigIdAttr in this.data) {
      const rigId = Number(this.data[rigIdAttr]);

      return !Number.isNaN(rigId) ? rigId : null;
    }

    return null;
  }
}
